<div mat-dialog-content class="w-full bg-white !p-0 !m-0">
  <form class="type-modal" [formGroup]="debtForm">
    <div class="card">
      <h3 class="green decoration mb-6">Generar deuda</h3>

      <div class="form-wrapper mb-3" [class.control-invalid]="debtForm.get('commercial_agreement_id').dirty && debtForm.get('commercial_agreement_id').invalid">
        <span>Nombre del comercio*</span>
        <mat-select formControlName="commercial_agreement_id" placeholder="Seleccione una opción" (selectionChange)="changeComertialAgreement($event)">
          <ng-container *ngIf="comertialAgreements; else elseComertialAgreements">
            <div class="filter_option">
              <input placeholder="Buscar..." [(ngModel)]="filterTerm" class="!outline-none" [ngModelOptions]="{standalone: true}">
            </div>
            <mat-option value="">Seleccione una opción</mat-option>
            <mat-option *ngFor="let comertialAgreement of comertialAgreements | filter: filterTerm; let i = index" [value]="comertialAgreement.id">{{ comertialAgreement.name_organization }}<ng-container *ngIf="comertialAgreement.businessUnitLabel"> ({{ comertialAgreement.businessUnitLabel }})</ng-container></mat-option>
          </ng-container>
          <ng-template #elseComertialAgreements>
            <mat-option value="">No se encontraron resultados...</mat-option>
          </ng-template>
        </mat-select>
        <p *ngIf="debtForm.get('commercial_agreement_id').dirty && debtForm.get('commercial_agreement_id').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="debtForm.get('commercial_agreement_id').errors.required">Este campo es necesario</label>
        </p>
      </div>

      <div class="flex gap-4 mb-3">
        <div class="form-wrapper mb-0 flex-1" [class.control-invalid]="debtForm.get('date').dirty && debtForm.get('date').invalid">
          <span>Fecha de deuda*</span>
          <input type="date" formControlName="date">
          <p *ngIf="debtForm.get('date').dirty && debtForm.get('date').invalid">
            <img src="../../../assets/img/x-circle.svg" alt="icon">
            <label *ngIf="debtForm.get('date').errors.required">Este campo es necesario</label>
          </p>
        </div>

        <div class="form-wrapper mb-0 flex-1" [class.control-invalid]="debtForm.get('max_payment_date').dirty && debtForm.get('max_payment_date').invalid">
          <span>Fecha máxima de pago*</span>
          <input type="date" formControlName="max_payment_date">
          <p *ngIf="debtForm.get('max_payment_date').dirty && debtForm.get('max_payment_date').invalid">
            <img src="../../../assets/img/x-circle.svg" alt="icon">
            <label *ngIf="debtForm.get('max_payment_date').errors.required">Este campo es necesario</label>
          </p>
        </div>
      </div>

      <div class="flex gap-4 mb-3">
        <div class="form-wrapper mb-0 flex-1">
          <span>Concepto</span>
          <input type="text" formControlName="concept" placeholder="Ej: Alquiler Dispositivo POS">
        </div>
      </div>

      <hr class="mb-3">

      <div class="flex justify-between items-center mb-3">
        <span class="font-semibold">Productos del acuerdo comercial</span>
        <button mat-button type="button" (click)="addItem()" class="btn btn-outline-primary">+ Agregar producto</button>
      </div>

      <div formArrayName="items">
        <div *ngFor="let item of items.controls; let i = index" [formGroupName]="i" class="flex gap-4 items-start mb-3">
          <div class="form-wrapper mb-0" style="flex: 2;" [class.control-invalid]="item.get('commercial_agreement_products_id').dirty && item.get('commercial_agreement_products_id').invalid">
            <span>Producto*</span>
            <mat-select formControlName="commercial_agreement_products_id" placeholder="Seleccione un producto">
              <mat-option value="">Seleccione una opción</mat-option>
              <mat-option *ngFor="let product of comertialAgreementProducts" [value]="product.id">{{ product.product_name }}<ng-container *ngIf="product.asset_serial_number"> ({{ product.asset_serial_number }})</ng-container></mat-option>
            </mat-select>
          </div>
          <div class="form-wrapper mb-0" style="flex: 1;" [class.control-invalid]="item.get('debt_amount').dirty && item.get('debt_amount').invalid">
            <span>Monto adeudado*</span>
            <input type="number" formControlName="debt_amount" placeholder="Ej: 100">
          </div>
          <button mat-button type="button" (click)="removeItem(i)" class="btn btn-outline-accent" style="margin-top: 22px;">
            <img src="../../../assets/qh-suite/icons/delete.svg" alt="icon">
          </button>
        </div>

        <p *ngIf="items.length === 0" class="text-gray-500">No se agregaron productos aún.</p> 
      </div>
    </div>
  </form>
</div>

<div mat-dialog-actions class="!m-0 w-full block">
  <div class="w-full flex justify-between actions_modal">
    <button mat-button type="button" (click)="dismiss()" class="btn btn-gray big">Cancelar</button>
    <button mat-button type="button" [disabled]="sending" (click)="submit()" class="btn btn-primary big">Registrar</button>
  </div>
</div>
